import { useMediaQuery } from "@mantine/hooks";
export default useMediaQuery;
